const togglerCls = "futt16w1md";
const playerTransitionDurationMs = 150;
const playerTransitionCls = "futpxfszzi";
const playerContainerCls = "futp1w91bpq";
const playerCls = "futp1hmmd7q";

export { playerCls, playerContainerCls, playerTransitionCls, playerTransitionDurationMs, togglerCls };
import "./_toggler.styles.linaria.module.css";
//# sourceMappingURL=_toggler.styles.js.map
